export default __webpack_public_path__ + "static/media/kitchen-pack-6.8ec1302d.png";